import { render, staticRenderFns } from "./ExpressLabelsTableUserHead.vue?vue&type=template&id=6b922079&scoped=true"
import script from "./ExpressLabelsTableUserHead.vue?vue&type=script&lang=js"
export * from "./ExpressLabelsTableUserHead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b922079",
  null
  
)

export default component.exports